import { RecurrenceWeekdayNumber } from '@akin-home/recurrence';
import React, { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { color, palette } from '../../theme';
import { Checkbox, CheckboxProps } from '../Checkbox/Checkbox';
import Text from '../Text';
import { styles } from './Weekdays.presets';

interface Props extends CheckboxProps {
  onChange: (id: RecurrenceWeekdayNumber, value: boolean) => void;
  id: RecurrenceWeekdayNumber;
  label: string;
  selected?: boolean;
}

export function DayCheckbox(props: Props): JSX.Element {
  const { id, label, selected, onChange, ...rest } = props;
  const [isChecked, setIsChecked] = useState(!!selected);

  const viewStyle = StyleSheet.flatten([
    styles.container,
    {
      backgroundColor: isChecked ? color.primary : 'rgba(5, 22, 51, 0.1)',
      borderColor: isChecked ? color.primary : 'lightgrey',
    },
  ]);

  const textStyle = StyleSheet.flatten([
    styles.text,
    {
      color: isChecked ? palette.white : palette.neutral_90,
    },
  ]);

  const handleChange = (): void => {
    onChange(id, !isChecked);
    setIsChecked(!isChecked);
  };

  return (
    <Pressable onPress={handleChange} style={styles.main}>
      <Checkbox {...rest} style={styles.hidden} value={isChecked} />
      <View style={viewStyle}>
        <Text style={textStyle} weight="semibold">
          {label}
        </Text>
      </View>
    </Pressable>
  );
}
